// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"7ff93fe8","456":"a8463b7a","656":"cbaf2aa1","756":"56a22ed3","968":"89a0dcff"}[chunkId] + ".chunk.js";
};